
import {LogoPoolEntry} from "./databaseInterfaceClasses";

export class LogoPoolStoreStatic {
    public static getLogoPoolIndexByTypeAndID(type, id, arrayToSearch=null):number {
        return LogoPoolStoreStatic.getFirstLogoPoolEntryIndexByProperties({type:type, id:id}, arrayToSearch);
    }

    public static getLogosNotInSecondArray(logoArray:LogoPoolEntry[], secondLogoArray:LogoPoolEntry[]) {
        return logoArray.filter(function(logo) {
            return LogoPoolStoreStatic.getLogoPoolEntryByTypeAndID(logo.type, logo.id, secondLogoArray) === null;
        });
    }
    public static getLogoPoolEntryByTypeAndID(type, id, arrayToSearch):LogoPoolEntry|null {
        return LogoPoolStoreStatic.getFirstLogoPoolEntryByProperties({type:type, id:id}, arrayToSearch);
    }
    public static getFirstLogoPoolEntryByProperties(properties, arrayToSearch):LogoPoolEntry|null {
        const index = LogoPoolStoreStatic.getFirstLogoPoolEntryIndexByProperties(properties, arrayToSearch);
        if(index > -1) {
            return arrayToSearch[index];
        }
        return null;
    }

    public static getFirstLogoPoolEntryIndexByProperties(properties, arrayToSearch):number {

        for(let i=0; i< arrayToSearch.length; i++) {
            if(LogoPoolStoreStatic.isEqualInProperties(arrayToSearch[i], properties)) {
                return i;
            }
        }
        return -1;
    }

    public static isEqualInProperties(entry, properties) {
        for(const prop in properties) {
            if(entry[prop] !== properties[prop]) {
                return false;
            }
        }
        return true;
    }
}
